import { Company } from 'module/api/company/types';
import { PageType } from 'api/page-template/types';
import { CompanyPage } from 'api/pages/types';
import moment from 'moment';
import { useGetPagesByTypeListQuery } from 'queries/pages';
import { useMemo } from 'react';

interface Props {
  company: Company;
  searchText: string;
}
interface Result {
  companyPages: CompanyPage[];
  allCompanyPages: CompanyPage[];
  isCompanyPagesLoading: boolean;
}
export const useCompanyPagesList = ({ company, searchText }: Props): Result => {
  const { data: companyPages, isLoading } = useGetPagesByTypeListQuery(
    company.companyId,
    `${PageType.Company},${PageType.Manual},${PageType.NitroExternal}`,
  );

  // If we have data (even if it's an empty array), we're not loading anymore
  // isLoading is true only when there's no data AND the query is still fetching
  const isCompanyPagesLoading = isLoading && companyPages === undefined;

  const sortedCompanyPages = useMemo(() => {
    return (
      (companyPages as CompanyPage[] | undefined)?.sort((a, b) => {
        return moment(b.startTime).diff(moment(a.startTime));
      }) ?? []
    );
  }, [companyPages]);

  const filteredCompanyPages = useMemo(() => {
    return sortedCompanyPages.filter((companyPage) =>
      companyPage.title?.toLowerCase().includes(searchText.toLowerCase()),
    );
  }, [sortedCompanyPages, searchText]);

  return {
    companyPages: filteredCompanyPages,
    allCompanyPages: sortedCompanyPages,
    isCompanyPagesLoading,
  };
};
